import { Link } from "react-router-dom";
import { MapPin, BedDouble, Bath, Maximize } from "lucide-react";
import { imageUrl } from "../lib/api";
import { priceLabel, typeLabel } from "../lib/constants";

const PropertyCard = ({ p }) => {
  const cover = imageUrl(p.images?.[0]) || "";
  const isResidential = !["plot", "agricultural-land"].includes(p.property_type);
  return (
    <Link to={`/property/${p.slug}`} data-testid={`property-card-${p.slug}`}
      className="group block bg-white rounded-2xl overflow-hidden border border-stone-200 hover-lift">
      <div className="relative aspect-[4/3] overflow-hidden bg-stone-100">
        {cover && <img src={cover} alt={p.title} loading="lazy" className="w-full h-full object-cover img-zoom" />}
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="rounded-full bg-stone-900/85 text-white text-[11px] font-semibold px-3 py-1 backdrop-blur">
            {p.listing_type === "rent" ? "For Rent" : "For Sale"}
          </span>
          {p.featured && (
            <span className="rounded-full bg-brand text-white text-[11px] font-semibold px-3 py-1">Featured</span>
          )}
        </div>
        {p.status !== "available" && (
          <div className="absolute inset-0 bg-black/40 grid place-items-center">
            <span className="uppercase tracking-widest text-white text-sm font-bold border border-white/70 px-4 py-1.5 rounded">
              {p.status}
            </span>
          </div>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-center justify-between gap-3 mb-1.5">
          <p className="font-heading text-xl text-stone-900">{priceLabel(p)}</p>
          <span className="text-[11px] uppercase tracking-wider text-brand font-semibold">{typeLabel(p.property_type)}</span>
        </div>
        <h3 className="text-base font-semibold text-stone-800 truncate">{p.title}</h3>
        <p className="flex items-center gap-1.5 text-sm text-stone-500 mt-1">
          <MapPin size={14} className="text-brand" /> {p.locality}, {p.city}
        </p>
        <div className="flex items-center gap-4 mt-4 pt-4 border-t border-stone-100 text-sm text-stone-600">
          {isResidential && (
            <>
              <span className="flex items-center gap-1.5"><BedDouble size={16} className="text-stone-400" />{p.bedrooms} BHK</span>
              <span className="flex items-center gap-1.5"><Bath size={16} className="text-stone-400" />{p.bathrooms}</span>
            </>
          )}
          <span className="flex items-center gap-1.5"><Maximize size={16} className="text-stone-400" />{p.area_value} {p.area_unit}</span>
        </div>
      </div>
    </Link>
  );
};

export default PropertyCard;
